export default "__VITE_ASSET__BWsQZbiB__"